import styled, { css } from 'styled-components';

export const ErrorBox = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors?.background?.main || '#ffffff'};
  border: 1px solid ${({ theme }) => theme.colors?.borders?.main || '#d8dee4'};
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors?.text?.main || '#1f2328'};
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat', sans-serif;
  gap: 12px;
  height: 100%;
  justify-content: center;
  min-height: 180px;
  padding: 24px;
  text-align: center;

  ${({ $variant }) => $variant === 'global' && css`
    inset: 0;
    min-height: auto;
    overflow: hidden;
    position: fixed;
  `}
`;

export const ErrorTitle = styled.strong`
  font-size: 16px;
  font-weight: 600;
`;

export const ErrorText = styled.p`
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  max-width: 360px;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.colors?.primary || '#1f6feb'};
  border: 1px solid transparent;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  min-height: 36px;
  padding: 8px 12px;
`;

export const SecondaryButton = styled.button`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors?.borders?.main || '#d8dee4'};
  border-radius: 6px;
  color: ${({ theme }) => theme.colors?.text?.main || '#1f2328'};
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  min-height: 36px;
  padding: 8px 12px;
`;
